module.exports = __webpack_public_path__ + "img/law.e23e85d5.svg";